import { render, staticRenderFns } from "./previousQuery.vue?vue&type=template&id=c5063678&scoped=true"
import script from "./previousQuery.vue?vue&type=script&lang=js"
export * from "./previousQuery.vue?vue&type=script&lang=js"
import style0 from "./previousQuery.vue?vue&type=style&index=0&id=c5063678&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5063678",
  null
  
)

export default component.exports